export const MAAS_UI_ID = "maas-ui";
